import { Injectable } from '@angular/core';
import { IPersonYoung } from '@model/client/person-young.model';
import { ILocalityClient, LocalityClient } from '@model/client/locality-client.model';
import dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class PersonValidatorService {
  validatePerson(person: IPersonYoung): string[] {
    const result = [];
    if (!person.young?.name) {
      result.push('Deves ter o nome preenchido no teu perfil.');
    }
    if (!person.person?.dateOfBirth) {
      result.push('Deves ter a data de nascimento preenchida no teu perfil.');
    }
    if (!person.person?.sex) {
      result.push('Deves ter o sexo preenchido no teu perfil.');
    }
    if (!person.young?.vatNumber) {
      result.push('Deves ter o nº. de contribuinte preenchido no teu perfil.');
    }
    if (!person.phones || person.phones.length < 1) {
      result.push('Deves ter um telefone de contacto inserido no teu perfil.');
    }
    if (!person.emails || person.emails.length < 1) {
      result.push('Deves ter um email de contacto inserido no teu perfil.');
    }
    const address = this.getAddress(person);
    if (!address) {
      result.push('Deves ter o teu endereço preenchido no teu perfil.');
    }
    if (!address?.districtName) {
      result.push('Deves ter o teu distrito de residência preenchido no teu perfil.');
    }
    if (!address?.countyName) {
      result.push('Deves ter o teu concelho de residência preenchido no teu perfil.');
    }
    return result;
  }

  getAge(person: IPersonYoung): number {
    const date1 = dayjs();
    if (person.person?.dateOfBirth) {
      return date1.diff(dayjs(person.person.dateOfBirth), 'years', false);
    }
    return 0;
  }

  getAddress(person: IPersonYoung): ILocalityClient | undefined {
    if (person.portugueseAddress && person.portugueseAddress.length > 0) {
      for (const portugueseAddress of person.portugueseAddress) {
        if (portugueseAddress.preferential) {
          return portugueseAddress.localityObject;
        }
      }
    }
    if (person.foreignAddress && person.foreignAddress.length > 0) {
      for (const foreignAddress of person.foreignAddress) {
        if (foreignAddress.preferential) {
          const locality = new LocalityClient();
          locality.localityName = foreignAddress.locality;
          locality.districtName = foreignAddress.city;
          return locality;
        }
      }
    }
    return undefined;
  }

  getPhone(person: IPersonYoung): string | undefined {
    if (person.phones && person.phones.length > 0) {
      for (const phone of person.phones) {
        if (phone.preferentialPhone) {
          return phone.phoneNumber;
        }
      }
    }
    return undefined;
  }

  getEmail(person: IPersonYoung): string | undefined {
    if (person.emails && person.emails.length > 0) {
      for (const email of person.emails) {
        if (email.preferentialEmail) {
          return email.email;
        }
      }
    }
    return undefined;
  }

  getIban(person: IPersonYoung): string | undefined {
    if (person.documents && person.documents.length > 0) {
      for (const document of person.documents) {
        if (document.documentType?.id === 4 && document.documentNumber) {
          return document.documentNumber;
        }
      }
    }
    return undefined;
  }
}
